import Vue from 'vue';
import SATracking from '@/shared/saTracking';
import type VueRouter from 'vue-router';
import { useUTMStore } from '@/stores/modules/utm';
import type { Pinia } from 'pinia';

/**
 * 设置神策埋点全局属性
 */
export function setupRegisterPageGuard(router: VueRouter, pinia: Pinia) {
  const utmStore = useUTMStore(pinia);

  router.beforeEach((to, from, next) => {
    // 先清除下页面中可能注册的全局埋点属性
    SATracking.clearPageRegister();

    // 设置埋点全局参数
    SATracking.registerPage({
      utm_source: to.query.utm_source ?? utmStore.source,
      platform_type: 'web',
      bu: 'yxh',
      referrer: window.__vue_router_referrer__,
    });

    next();
  });
}

/**
 * 神策默认PV埋点
 * 不使用is_track_single_page是因为统计到的title是变更前的
 */
export function trackPageViewGuard(router: VueRouter) {
  router.afterEach((to) => {
    Vue.nextTick(() => {
      if (!to.meta?.excludeTracking) {
        SATracking.trackPageView();
      }
    });
  });
}
